'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findDefaultIcon = undefined;

var _elementActions = require('../../element/elementActions');

var _elementIconService = require('./elementIconService');

var _elementHelper = require('../../../common/elements/elementHelper');

var _makeStringIconDef = require('./makeStringIconDef');

var _makeStringIconDef2 = _interopRequireDefault(_makeStringIconDef);

var _stringUtil = require('../../../common/utils/stringUtil');

var _elementConstants = require('../../../common/elements/elementConstants');

var TYPES = _interopRequireWildcard(_elementConstants);

var _boardConstants = require('../../../common/boards/boardConstants');

var _elementIconConstants = require('./elementIconConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeFallbackBoardIcon = function makeFallbackBoardIcon(_ref) {
    var id = _ref.id,
        transactionId = _ref.transactionId;
    return function (dispatch, getState) {
        var state = getState();
        var element = state.get('elements').get(id);
        var title = element && element.getIn(['content', 'title']) || _boardConstants.BOARD_DEFAULT_TITLE;
        var stringIcon = void 0;

        if (title === _boardConstants.BOARD_DEFAULT_TITLE) {
            var elementParentId = element.getIn(['location', 'parentId']);
            var peerBoards = (0, _elementHelper.getChildren)(state.get('elements'), elementParentId).filter(function (el) {
                return el.get('elementType') === _boardConstants.BOARD_TYPE && el.getIn(['content', 'title']) === _boardConstants.BOARD_DEFAULT_TITLE;
            });

            var boardsCount = peerBoards.size % 10;
            stringIcon = (0, _makeStringIconDef2.default)(boardsCount.toString(10));
        } else {
            var titleLetters = (0, _stringUtil.slugify)(title, '-').split('-').map(function (word) {
                return word[0];
            });
            if (titleLetters <= _elementIconConstants.STRING_ICON_MAX_LENGTH) {
                stringIcon = (0, _makeStringIconDef2.default)(titleLetters.join(''));
            } else {
                stringIcon = (0, _makeStringIconDef2.default)(titleLetters[0]);
            }
        }

        dispatch((0, _elementActions.updateElement)({
            type: TYPES.ELEMENT_UPDATE,
            id: id,
            changes: {
                icon: stringIcon
            },
            transactionId: transactionId
        }));
    };
};

var findDefaultIcon = exports.findDefaultIcon = function findDefaultIcon(_ref2) {
    var id = _ref2.id,
        query = _ref2.query,
        transactionId = _ref2.transactionId;
    return function (dispatch, getState) {
        var element = getState().get('elements').get(id);
        var title = element && element.get('content').get('title') || _boardConstants.BOARD_DEFAULT_TITLE;

        if (title === _boardConstants.BOARD_DEFAULT_TITLE) {
            return dispatch(makeFallbackBoardIcon({ id: id, transactionId: transactionId }));
        }

        dispatch({
            type: TYPES.ELEMENT_ICON_FIND,
            id: id,
            query: query
        });

        (0, _elementIconService.searchForIcon)(query, 1).then(function (response) {
            var icons = response.data.icons;

            if (!icons.length) throw new Error('No icons found');

            dispatch({ type: TYPES.ELEMENT_ICON_FIND_SUCCESS, id: id });

            var icon = icons[0];

            dispatch((0, _elementActions.updateElement)({
                type: TYPES.ELEMENT_UPDATE,
                id: id,
                changes: {
                    icon: icon
                },
                transactionId: transactionId
            }));
        }).catch(function () {
            dispatch(makeFallbackBoardIcon({ id: id, transactionId: transactionId }));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/elementIcon/elementIconActions.js
// module id = 1756
// module chunks = 0